/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import type { ApolloError } from 'apollo-client';

import { markErrorAsHandled } from '@confluence/graphql';
import { getStatusCode } from '@confluence/error-boundary';

import type { useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery as useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data } from './__types__/useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery';

type UseOrgDefaultClassificationLevelIdProps = {
	skip?: boolean;
};

type UseOrgDefaultClassificationLevelIdType = {
	orgDefaultClassificationLevelId: string | null;
	orgDefaultClasificationLoading: boolean;
	orgDefaultClassificationError?: ApolloError;
};

const shouldMarkErrorAsHandled = (error?: ApolloError) => {
	if (!error) return true;
	const statusCode = getStatusCode(error?.graphQLErrors?.[0]);
	if (!statusCode) return true;
	return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};

export const useOrgDefaultClassificationLevelId = ({
	skip,
}: UseOrgDefaultClassificationLevelIdProps): UseOrgDefaultClassificationLevelIdType => {
	const { data, loading, error } =
		useQuery<useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data>(
			gql`
				query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery {
					orgDefaultClassificationLevelId
				}
			`,
			{ skip },
		);

	if (shouldMarkErrorAsHandled(error)) {
		markErrorAsHandled(error);
	}

	const orgDefaultClassificationLevelId = data?.orgDefaultClassificationLevelId ?? null;

	return {
		orgDefaultClassificationLevelId,
		orgDefaultClasificationLoading: loading,
		orgDefaultClassificationError: !shouldMarkErrorAsHandled(error) ? error : undefined,
	};
};
